export const messages = [
    {
        id: 1,
        alignment: "left",
        heading1: "Prime",
        heading2: "Locations",
        main: "We focus on prime locations that offer optimal accessibility to key transportation, power and people, ensuring seamless logistics operations for our clients.",
    },
    {
        id: 2,
        alignment: "right",
        heading1: "Future",
        heading2: "Growth",
        main: "We aim to select sites with potential for future expansion, allowing clients to grow their operations if needed. Our commitment to finding the right land is foundational to delivering exceptional value and long-term success for our clients.",
    },
    {
        id: 3,
        alignment: "left",
        heading1: "Footprint",
        heading2: "Flexibility",
        main: "With build to suit projects, once we have achieved planning there is the opportunity to adjust the site plan and building footprint to align with our client's needs.",
    },
    {
        id: 4,
        alignment: "centerW",
        heading1: "1. CONSTRUCTING OUR BOXES",
        heading2: "",
        heading3: "",
        main: "Our minimum BREEAM rating for any building is Excellent and our EPC rating is A. To achieve this we ensure our building specification meets a number of criteria.",
    },
    {
        id: 5,
        alignment: "left",
        heading1: "Construction",
        main: "Construction begins with a plateaued level surface of the floorplan and surrounding area.",
    },
    {
        id: 6,
        alignment: "right",
        heading1: "Portal",
        heading2: "Frame",
        main: "This base enables the erection of the portal structural frame with equal spans and bay spacing.",
    },
    {
        id: 7,
        alignment: "right",
        heading1: "Floor",
        heading2: "Slab",
        main: "Meanwhile inside the concrete slab is laid...",
    },
    {
        id: 8,
        alignment: "left",
        heading1: "Metal",
        heading2: "Cladding",
        main: "We clad the building with a highly insulated composite metal, which is guaranteed for 25 years.",
    },
    {
        id: 9,
        alignment: "left",
        heading1: "Net",
        heading2: "Zero",
        main: "All our buildings are built to Net Zero Carbon in construction, meaning that total carbon emissions produced during construction is balanced by offsetting an equivalent amount of carbon, resulting in a no net increase in CO2.",
    },
    {
        id: 10,
        alignment: "left",
        heading1: "Loading",
        heading2: "Doors",
        main: "All our buildings benefit from both dock leveller doors and level access doors (standard and jumbo).",
    },
    {
        id: 11,
        alignment: "left",
        heading1: "Constant",
        heading2: "Refinement",
        main: "We are constantly improving our market leading specification to use more low carbon construction materials and methodologies and help our clients meet their decarbonisation targets.",
    },
    {
        id: 12,
        alignment: "right",
        heading1: "Practical",
        heading2: "Completion",
        main: "For a typical 250,000 sq ft building, practical completion is achieved in 42 weeks but can be accelerated based on client requirements.",
    },
    {
        id: 13,
        alignment: "centerW",
        heading1: "2. ENERGY SERVICES",
        heading2: "",
        heading3: "",
        main: "We are focused on helping our clients hit their decarbonisation targets and power demands and our latest parks and buildings feature a number of energy innovations to help deliver this...",
    },
    {
        id: 14,
        alignment: "left",
        heading1: "Power",
        heading2: "Integration",
        main: "Energy services is the integration of grid power, rooftop solar batteries and backup, to optimise and integrate onsite energy generation, delivering power to our clients, now and into the future.",
    },
    {
        id: 15,
        alignment: "left",
        heading1: "Private",
        heading2: "Wire",
        main: "We have implemented privately owned electricity networks across a number of our parks, commonly known as 'private wires'. These are localised power distribution networks connecting grid power and solar into one system, designed to integrate alongside batteries and backup generation.",
    },
    {
        id: 16,
        alignment: "right",
        heading1: "Balancing",
        heading2: "Power Demand",
        main: "This enables energy generated by solar panels to be balanced and delivered across each building according to demand, and providing backup in the event of grid failure.",
    },
    {
        id: 17,
        alignment: "left",
        heading1: "Up To",
        heading2: "100% Solar",
        main: "All new buildings are designed to maximise energy efficiency, and allow up to 100% of the usable roof area to be covered with rooftop solar panels.",
    },
    {
        id: 18,
        alignment: "left",
        heading1: "Initial",
        heading2: "Array",
        main: "Each new building is delivered with an initial solar array and, where possible, optimised to a client's requirements.",
    },
    {
        id: 19,
        alignment: "left",
        heading1: "Adapting to",
        heading2: "the Future",
        main: "Should a client's power requirements increase, future expansion of the solar array is easily accommodated.",
    },
    {
        id: 20,
        alignment: "centerW",
        heading1: "3. EVOLVING SPECIFICATION",
        heading2: "",
        heading3: "",
        main: "Like the outside of our buildings we are constantly refining and improving our standard specification on the inside too, so they are more pleasant to work in and economical to run...",
    },
    {
        id: 21,
        alignment: "left",
        heading1: "Natural",
        heading2: "Light",
        main: "A minimum of 10% roof lighting ensures natural daylight is available all year round, which is more pleasant for people, whilst also saving energy.",
    },
    {
        id: 22,
        alignment: "left",
        heading1: "Heavy and Very",
        heading2: "Flat Floors",
        main: "Our floors are designed to withstand a minimum of 50kN/m2 and are very level with a  maximum differential tolerance of 6.5mm over any two points three metres apart.",
    },
    {
        id: 23,
        alignment: "left",
        heading1: "Forklift",
        heading2: "Ready",
        main: "Typical eaves height range from 12m to 18m clear.",
    },
    {
        id: 24,
        alignment: "left",
        heading1: "Flexible",
        heading2: "Space",
        main: "All this delivers a flexible space to accommodate our client's needs and support their business ambitions.",
    },
    {
        id: 25,
        alignment: "right",
        heading1: "Impressive",
        heading2: "Space",
        main: "All lobbies feature impressive full height glazing atriums with revolving entrance doors to welcome staff and visitors.",
    },
    {
        id: 26,
        alignment: "left",
        heading1: "Efficient Heating",
        heading2: "& Cooling",
        main: "Our office areas are heated and cooled via an energy efficient Variable Air Volume (VAV) air conditioning system. An air source heat pump is installed in the office, lobby and primary circulation areas, to help reduce energy consumption.",
    },
    {
        id: 27,
        alignment: "left",
        heading1: "Smart LED",
        heading2: "Lighting",
        main: "Office lighting incorporating daylight control and dimming with presence detection control.",
    },
    {
        id: 28,
        alignment: "right",
        heading1: "Flexible",
        heading2: "Space",
        main: "Our offices are light, open and airy with full height glazing. Clients can customise the area to their specific needs. Offices benefit from raised access floors and metal tile suspended ceilings.",
    },
    {
        id: 29,
        alignment: "left",
        heading1: "Oven",
        heading2: "Ready",
        main: "A kitchenette is installed featuring a fridge, dishwasher and instant hot tap.",
    },
    {
        id: 30,
        alignment: "centerW",
        heading1: "4. EXTERNAL & WELLBEING FEATURES",
        heading2: "",
        heading3: "",
        main: "We design our parks with employee wellbeing in mind, creating environments that promote a positive work-life experience...",
    },
    {
        id: 31,
        alignment: "left",
        heading1: "Brise",
        heading2: "Soleil",
        main: "We help provide solar shading for office workers with brise soleil.",
    },
    {
        id: 32,
        alignment: "right",
        heading1: "Ready",
        heading2: "for EV(s)",
        main: "20% of car spaces are provided with EV chargers. Ductwork allows for future installation of car chargers in all remaining car spaces.",
    },
    {
        id: 33,
        alignment: "left",
        heading1: "Ready",
        heading2: "for E HGV(s)",
        main: "Our latest parks are now future proofed by making provision for van and HGV charging points.",
    },
    // {
    //     id: 34,
    //     alignment: "centerW",
    //     heading1: "Wellbeing.",
    //     main: "Employee wellbeing is a key consideration and where possible we aim to include features to make our parks more enjoyable places to work",
    // },
    {
        id: 34,
        alignment: "left",
        heading1: "Cycle",
        heading2: "Racking",
        main: "Covered cycle racks are provided to encourage employees to cycle to work.",
    },
    {
        id: 35,
        alignment: "left",
        heading1: "Al",
        heading2: "Fresco",
        main: "Where possible we include a variety of outdoor spaces for employees and the local community including picnic areas to eat and socialise...",
    },
    {
        id: 36,
        alignment: "left",
        heading1: "",
        main: "...Where possible we work with local councils to include transport links to our parks ensuring convenient access for staff, helping with employee satisfaction and retention.",
    },
    {
        id: 37,
        alignment: "left",
        heading1: "",
        main: "...There are also outdoor gyms to encourage health and wellbeing.",
    },
    {
        id: 38,
        alignment: "left",
        heading1: "",
        main: "...and running trails enabling employees to stretch their legs and experience nature away from the workplace",
    },
    // {
    //     id: 39,
    //     alignment: "centerO",
    //     heading1: "Community",
    //     heading2: "Focused",
    //     heading3: ".",
    //     main: "We aim to support local communities in and around our developments. Our spaces are designed to encourage social interaction and engagement",
    // },
];

export const submessages = [
    {
        id: 1,
        heading: "",
        main: "Inside, our standard specification includes...",
        //start 433, end 592
    },
];

export const startmessages = [
    {
        id: 1,
        heading1: "INSIDE THE BOX",
        heading2: "DISCOVER OUR BUILDINGS",
        main: "Modern Industrial and Logistics parks are arguably the most utilitarian buildings today. We build ours to exacting and sustainable standards, whilst always ensuring employee wellbeing.",
        instructions: "Scroll to find out how we build our Boxes...",
    },
];
